module.exports = __webpack_public_path__ + "6614166b0c0e67b23e009beb2a7093b5.svg";